import React, { useContext, useMemo, useEffect } from 'react';
import P from 'prop-types';
import { GlobalContext } from '../../contexts/HomeContext';
import { Produtos } from '../Produtos';
import { verificaDiasRestricao } from '../../utils/utils';

const _categoriaDefault = {
  atualizado: 1,
  back_color: '0;100;0',
  categoria_ecommerce: '',
  codigo_operador: 1,
  datahora: '2021-12-16T14:32:35',
  dom: 1,
  ecommerce_subgrupo_principal: '',
  excluido: 0,
  fore_color: 'White',
  grupo: '',
  hora_final_dom: '23:59',
  hora_final_qua: '23:59',
  hora_final_qui: '23:59',
  hora_final_sab: '23:59',
  hora_final_seg: '23:59',
  hora_final_sex: '23:59',
  hora_final_ter: '23:59',
  hora_inicio_dom: '0:00',
  hora_inicio_qua: '0:00',
  hora_inicio_qui: '0:00',
  hora_inicio_sab: '0:00',
  hora_inicio_seg: '0:00',
  hora_inicio_sex: '0:00',
  hora_inicio_ter: '0:00',
  id: 138,
  idloja: 2,
  nome_operador: 'JAMES ROCHA',
  numero_cx: 12,
  ordem: 14,
  ordem_app: 9999,
  pendente_exportacao: 0,
  qua: 1,
  qui: 1,
  sab: 1,
  seg: 1,
  sex: 1,
  subgrupo: '',
  ter: 1,
};

export const ResultadoBusca = ({ searchTerm, onCountChange, onOpenItem, onClose, onAdded }) => {
  const { dadosApp } = useContext(GlobalContext);

  const produtos = useMemo(() => {
    const termo = (searchTerm || '').trim();
    if (!termo) return [];
    return dadosApp.Cardapio.Produtos.filter(
      (produto) =>
        produto.descricao.toLowerCase().includes(termo.toLowerCase()) && produto.is_subitem_multpreco === false,
    );
  }, [searchTerm, dadosApp.Cardapio.Produtos]);

  useEffect(() => {
    if (onCountChange) onCountChange(produtos.length);
  }, [produtos.length, onCountChange]);

  return (
    <div style={{ margin: '20px 15px 30px', textAlign: 'center', minHeight: 333 }}>
      <div className="row">
        <div className="col-lg-6" style={{ textAlign: 'left' }}>
          {produtos.map((produto, index) => {
            let _categoria = dadosApp.Cardapio.Categorias.filter((item) => {
              if (produto.categoria_ecommerce !== '') return item.categoria_ecommerce === produto.categoria_ecommerce;
              return item.subgrupo === produto.subgrupo;
            });
            if (_categoria.length === 0) _categoria.push(_categoriaDefault);
            const diasRestricao = verificaDiasRestricao(dadosApp.DiaSemana, _categoria[0]);
            if (dadosApp.TipoApp === 'MESA') diasRestricao.podeVender = true;
            return (
              <Produtos
                key={index}
                diasRestricao={diasRestricao}
                item={produto}
                isSearch={true}
                onOpen={onOpenItem}
                onClose={onClose}
                onAdded={onAdded}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

ResultadoBusca.propTypes = {
  searchTerm: P.string,
  onCountChange: P.func,
  onOpenItem: P.func,
  onClose: P.func,
  onAdded: P.func,
};
